module.exports = __webpack_public_path__ + "static/img/title-banner1-type1.81f30e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/7/title-banner1-type1.png
// module id = UPsY
// module chunks = 1